/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, makeStyles, MessageBar, MessageBarActions, MessageBarBody, MessageBarGroup, MessageBarTitle } from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";
import { AppMessage } from "../../data/types";
import { useState } from "react";

const useStyles = makeStyles({
    messageBarGroup: {
        width: '100%',
        height:'auto'
    }
})

type AppMessageDisplayProps = {
    messages?: AppMessage[];
    onDismiss?: (id: string) => void;
}
export const AppMessageDisplay = (props: AppMessageDisplayProps) => {

    const { messages = [], onDismiss } = props;

    //Styles
    const styles = useStyles();

    //UI Events
    const clickDismissMessage = (e:any, id: string) => {
        e.stopPropagation();

        dismissMessage(id);
    }


    //Logic
    const dismissMessage = (id: string) => {
        !!onDismiss && onDismiss(id);
    }

    return (
        <MessageBarGroup animate='both' className={styles.messageBarGroup}>
            {messages.map(({ id, intent, title, content, actions, canDismiss=true }) => (
                <MessageBar key={`${intent}-${id}`} intent={intent}>
                    <MessageBarBody>
                        <MessageBarTitle>{title}</MessageBarTitle>
                        {content}
                    </MessageBarBody>
                    <MessageBarActions
                        containerAction={
                            <>
                                {!!onDismiss && canDismiss &&
                                    <Button
                                        onClick={(e:any) => clickDismissMessage(e, id)}
                                        aria-label="dismiss"
                                        appearance="transparent"
                                        icon={<DismissRegular />}
                                        data-testid={`app-message-dismiss-button-${id}`}
                                    />
                                }
                            </>
                        }
                    >
                        {actions}
                    </MessageBarActions>
                </MessageBar>
            ))}
        </MessageBarGroup>
    );
}

export const useAppMessageDisplay = () => {

    const [messages, setMessages] = useState<AppMessage[]>([]);

    const addMessage = (msg: AppMessage) => {
        setMessages((prev) => [...(prev.filter((x) => x.id != msg.id)), msg]);
    }
    const removeMessage = (id: string) => {
        setMessages((prev) => prev.filter(x => x.id != id));
    }
    const clearMessage = () => {
        setMessages([]); 
    }

    return {
        messages,
        addMessage,
        removeMessage,
        clearMessage
    }
}